/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import MEITotalSalestPage from 'src/pages/ReportsPages/ReportsBoard/MEIpages/MEITotalSalesPage'
import boardReportsService from 'src/services/boardReportsService'

const MEITotalSalesContainer = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [table1a, setTable1a] = useState([])
  const [table1b, setTable1b] = useState([])
  const [gTotal1, setTotalG1] = useState([])
  const [totalSellInRegion, setTotalSellInRegion] = useState([])
  const [totalSellOutRegion, setTotalSellOutRegion] = useState([])
  const [totalbyTerritory, setTotalbyTerritory] = useState([])
  const [gATotalTerritory, setATotalTerritory] = useState([])
  const [gBTotalTerritory, setBTotalTerritory] = useState([])

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  const reloadImports = async () => {
    const [
      table1a,
      table1b,
      totalSellInRegion,
      totalSellOutRegion,
      gTotal1,
      totalbyTerritory,
      gATotalTerritory,
      gBTotalTerritory,
    ] = await Promise.all([
      boardReportsService.getTotalSalesMEI('1a', selectedDate.getFullYear()),
      boardReportsService.getTotalSalesMEI('1b', selectedDate.getFullYear()),
      boardReportsService.getTotalSalesMEI('2', selectedDate.getFullYear()),
      boardReportsService.getTotalSalesMEI('3', selectedDate.getFullYear()),
      boardReportsService.graphicsTotalSalesMEI('1', selectedDate.getFullYear()),
      boardReportsService.getTotalSalesMEI(4, selectedDate.getFullYear()),
      boardReportsService.graphicsTotalSalesMEI('2a', selectedDate.getFullYear()),
      boardReportsService.graphicsTotalSalesMEI('2b', selectedDate.getFullYear()),
    ])
    setTable1a(table1a)
    setTable1b(table1b)
    setTotalSellInRegion(totalSellInRegion)
    setTotalSellOutRegion(totalSellOutRegion)
    setTotalG1(gTotal1)
    setTotalbyTerritory(totalbyTerritory)
    setATotalTerritory(gATotalTerritory)
    setBTotalTerritory(gBTotalTerritory)
  }

  useEffect(() => {
    reloadImports()
  }, [])

  return (
    <MEITotalSalestPage
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
      table1a={table1a}
      table1b={table1b}
      gTotal1={gTotal1}
      totalSellInRegion={totalSellInRegion}
      totalSellOutRegion={totalSellOutRegion}
      gATotalTerritory={gATotalTerritory}
      gBTotalTerritory={gBTotalTerritory}
      totalbyTerritory={totalbyTerritory}
    />
  )
}

export default MEITotalSalesContainer
